import React from 'react';
import { createStyles } from 'app/utils/css';
import { RED_G } from 'app/constants/Colors';
import MarginGroup from 'app/components/layout/MarginGroup';

interface IProps {
  message?: React.ReactNode;
}

const ValidationError: React.SFC<IProps> = ({ message, children }) => (
  <Styles>{(css) =>
    <MarginGroup margin="5px">
      {children && <div>{children}</div>}

      {message && (
        <div className={css('error')}>
          {message}
        </div>
      )}
    </MarginGroup>
  }</Styles>
);

const Styles = createStyles({
  error: {
    color: RED_G,
  },
});

export default ValidationError;
